<template>
  <v-card :loading="loading" class="pa-4" flat>
    <v-card-title class="pb-5">
      <v-btn :loading="loading" class="submit-btn" @click="updateCategory">
        <v-icon>mdi-update</v-icon>
        بروز رسانی
      </v-btn>
      <!--                            <v-card elevation="2" outlined>-->
    </v-card-title>

    <v-row class="pa-2" no-gutters>
      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-text-field
          v-model="name"
          :error-messages="errors.name"
          :rules="rules.name"
          autofocus
          dense
          label="اسم"
          outlined
          required
          @keypress.enter="updateCategory"
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-text-field
          v-model="image"
          :error-messages="errors.image"
          dense
          label="کد ایکون"
          outlined
          required
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="special"
          :error-messages="errors.service"
          :items="specials"
          :menu-props="{ offsetY: true }"
          :rules="rules.special"
          dense
          label="منو سربرگ"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="service"
          :error-messages="errors.service"
          :items="services"
          :menu-props="{ offsetY: true }"
          :rules="rules.service"
          dense
          item-text="nameLand"
          item-value="id"
          label="انتخاب سرویس"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="status"
          :items="types"
          :menu-props="{ offsetY: true }"
          :rules="rules.type"
          dense
          label="وضعیت نمایش"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-text-field v-model="link" dense label="پیوند" outlined />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-text-field
          v-model="sortOrder"
          :error-messages="errors.sort_order"
          dense
          label="اولویت نمایش"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="meta_title"
          :error-messages="errors.meta_title"
          :items="roles"
          :menu-props="{ offsetY: true }"
          dense
          item-text="name"
          item-value="value"
          label="سطح دسترسی"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="parentId"
          :items="parents"
          :menu-props="{ offsetY: true }"
          clearable
          dense
          item-text="name"
          item-value="id"
          label="دسته بندی والد"
          outlined
        />
      </v-flex>

      <v-flex class="p-2" lg12 md12 sm12 xl12 xs12>
        <v-text-field
          v-model="gate"
          :error-messages="errors.gate"
          dense
          hint="اگر پرمیشن ندارد خالی بگذارید."
          label="پرمیشن"
          outlined
        />
      </v-flex>

      <v-container fluid>
        <v-label>توضیحات</v-label>

        <ckeditor
          v-model="description"
          :config="editor.editorConfig"
          :editor="editor.editor"
        >
        </ckeditor>
      </v-container>
    </v-row>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";

export default {
  props: ["id"],
  data() {
    return {
      loading: false,
      gate: null,
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      roles: [
        { name: "ادمین", value: "admin" },
        { name: "کاربر", value: "user" },
      ],
      meta_title: null,
      service: null,
      status: null,
      parentId: null,
      services: [],
      query: { sort: "id", order: "desc", limit: 100, s: "" },
      rules: {
        name: [(val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد"],
        services: [(val) => !!val || "فیلد سرویس الزامی می باشد"],
        status: [(val) => !!val || "فیلد وضعیت الزامی می باشد"],
      },
      specials: [
        { text: "بله", value: 1 },
        { text: "خیر", value: 0 },
      ],
      special: null,
      types: [
        { text: "نمایش", value: 1 },
        { text: "عدم نمایش", value: 0 },
        { text: "غیرفعال", value: 2 },
      ],
      name: "",
      description: "",
      image: null,
      link: "",
      sortOrder: "",
      errors: [],
      parents: [],
    };
  },

  created() {
    this.getCategory();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  async mounted() {
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService().data
    this.getParents();
  },

  methods: {
    getParents() {
      this.requestApiGet(`category/getParents`)
        .then(({ data }) => {
          this.parents = data;
        })
        .catch((e) => {});
    },
    updateCategory() {
      this.loading = true;

      // fill disabled field from status field
      let disabled = 0;
      if (this.status === 2) {
        disabled = 1;
        this.status = 0;
      } else {
        disabled = 0;
      }

      this.requestApiPost(`categories/${this.id}`, {
        name: this.name,
        description: this.description,
        image: this.image,
        gate: this.gate,
        slug: this.link,
        sort_order: this.sortOrder,
        parent_id: this.parentId,
        service_id: this.service,
        status: this.status,
        meta_title: this.meta_title,
        special: this.special,
        disabled,
        _method: "PUT",
      })
        .then((response) => {
          this.goto("category");
          this.$toast.success("با موفقیت به روز رسانی شد");
        })
        .catch(({ response }) => {
          this.errors = response;
        })
        .finally(() => (this.loading = false));
    },
    getCategory() {
      this.loading = true;

      this.requestApiGet(`categories/${this.id}`)
        .then(({ data }) => {
          this.service = data.service_id;
          this.name = data.name;
          this.gate = data.gate;
          this.description = data.description;
          this.parentId = data.parent_id;
          this.status = !!data.disabled ? 2 : data.status;
          this.special = data.special;
          this.sortOrder = data.sort_order;
          this.meta_title = data.meta_title;
          this.link = data.slug;
          this.image = data.image;
        })
        .catch((e) => {})
        .finally(() => (this.loading = false));
    },
  },
};
</script>
